// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_ImportacaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /rede/importar — o plano da importação (ensaio) ou o que foi gravado (aplicar). */
import type { Rede_ContagemRow } from './Rede_ContagemRow'
import type { Rede_ImportacaoCasadaRow } from './Rede_ImportacaoCasadaRow'
import type { Rede_ImportacaoForaRow } from './Rede_ImportacaoForaRow'
import type { Rede_ImportacaoPendenciaRow } from './Rede_ImportacaoPendenciaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Rede_ImportacaoResponseDados {
aplicado: boolean
linhas: number
casadas_total: number
externas_total: number
externas_por_situacao: Rede_ContagemRow[]
situacoes_a_registrar: number
divergencias: number
ambiguas: number
encerramentos_total: number
encerramentos_a_conferir: number
fichas_total: number
socios_total: number
casadas: Rede_ImportacaoCasadaRow[]
pendencias: Rede_ImportacaoPendenciaRow[]
fora_da_planilha: Rede_ImportacaoForaRow[]
}

export type Rede_ImportacaoResponse = ApiResponse<Rede_ImportacaoResponseDados>;

registerResponseContract('Rede_ImportacaoResponse', {
  aplicado:                 { type: 'boolean', required: true },
  linhas:                   { type: 'number',  required: true },
  casadas_total:            { type: 'number',  required: true },
  externas_total:           { type: 'number',  required: true },
  externas_por_situacao: {
    type: 'array',
    required: true,
    items: {
      chave:  { type: 'string',  required: true },
      rotulo: { type: 'string',  required: false },
      total:  { type: 'number',  required: false },
    },
  },
  situacoes_a_registrar:    { type: 'number',  required: true },
  divergencias:             { type: 'number',  required: true },
  ambiguas:                 { type: 'number',  required: true },
  encerramentos_total:      { type: 'number',  required: true },
  encerramentos_a_conferir: { type: 'number',  required: true },
  fichas_total:             { type: 'number',  required: true },
  socios_total:             { type: 'number',  required: true },
  casadas: {
    type: 'array',
    required: true,
    items: {
      numero:         { type: 'number',  required: true },
      linha:          { type: 'number',  required: false },
      unidade:        { type: 'string',  required: false },
      franquia_id:    { type: 'number',  required: true },
      franquia_nome:  { type: 'string',  required: false },
      como:           { type: 'string',  required: false },
      situacao:       { type: 'string',  required: false },
      desde:          { type: 'string',  required: false },
      acao:           { type: 'string',  required: false },
      situacao_atual: { type: 'string',  required: false },
      inaugurado_em:  { type: 'string',  required: false },
      pasta:          { type: 'string',  required: false },
    },
  },
  pendencias: {
    type: 'array',
    required: true,
    items: {
      tipo:    { type: 'string',  required: false },
      aba:     { type: 'string',  required: false },
      linha:   { type: 'number',  required: false },
      unidade: { type: 'string',  required: false },
      texto:   { type: 'string',  required: false },
    },
  },
  fora_da_planilha: {
    type: 'array',
    required: true,
    items: {
      franquia_id: { type: 'number',  required: true },
      nome:        { type: 'string',  required: false },
    },
  },
})
